import Backbone from 'backbone';
import { on, off, getElement } from 'utils/mixins';
import Tools from '../../services/Tools';
import 'regenerator-runtime/runtime';

const queryString = require('query-string');

var MobileDetect = require('mobile-detect');
const md = new MobileDetect(navigator.userAgent);
var platform = require('platform');

const $ = Backbone.$;

module.exports = Backbone.View.extend({
  initialize(o) {
    _.bindAll(
      this,
      'handleSocketConnected',
      'handleSocketReceiveMessage',
      'handleEndChat',
      'handleSocketDisconnected'
    );
    this.config = o.config || {};
    this.pfx = this.config.stylePrefix || '';
  },

  connect() {
    const { model, config } = this;
    this.socket = require('socket.io-client')(this.config.domainSocket, {
      path: '/chattool-socket',
      transports: ['websocket']
    });
    this.socket.on('connect', this.handleSocketConnected);
  },

  getId() {
    let id = (this.socket && this.socket.id) || '';
    const ids = id && id.split('#');
    if (ids && ids.length) {
      id = ids[ids.length - 1];
    }
    return `${id}`.trim();
  },

  isConnected() {
    return !this.model.get('disconnect');
  },

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  },

  sendMessage(data, callback = null) {
    const { socket, model, config } = this;
    const disconnect = model.get('disconnect');
    if (disconnect || !socket) {
      return;
    }
    socket.emit('send_message', data, function(val) {
      if (callback) {
        callback(val, data);
      }
    });
  },

  emitAllVisitor(data, callback = null) {
    const { socket, model, config } = this;
    const disconnect = model.get('disconnect');
    if (disconnect || !socket) {
      return;
    }
    socket.emit('emit_all_visitor', data, function(val) {});
  },

  emit(cmd, params, callback) {
    const disconnect = this.model.get('disconnect');
    if (!this.socket || !disconnect) {
      return;
    }
    this.socket.emit(cmd, params, function(val) {
      callback && callback(val);
    });
  },

  handleSocketConnected() {
    const { config, model } = this;
    const userId = config.userId || Tools.getUserId(config.domain_id);
    const sessionId = Tools.getSessionId(config.domain_id);
    model.set('disconnect', false);
    config.connected = true;
    this.socket.emit(
      'send_cookie',
      {
        cookie_id: userId,
        domain_id: config.domain_id,
        name_device: platform.product,
        os: platform.os.family,
        os_version: platform.os.version,
        os_code_name: '',
        browser: platform.name,
        browser_version: platform.version,
        device_brand: platform.manufacturer,
        device_type: md.mobile() ? 'mobile' : 'desktop',
        device_screen_ratio: 0,
        device_screen_height: screen.height,
        device_screen_width: screen.width,
        device_gpu: '',
        url: window.location.href,
        url_title: document.title
      },
      function(val) {
        if (!userId) {
          Tools.setUserId(config.domain_id, val.cookie_id);
          config.currUserId = val.cookie_id;
        }
        if (val.session_id !== sessionId) {
          Tools.setSessionId(val.session_id, config.domain_id);
          config.currSessionId = val.session_id;
        }
        model.trigger('onSendCookie', userId || val.cookie_id, val.session_id);
      }
    );

    // receive message
    this.socket.on('receive_message', this.handleSocketReceiveMessage);

    // disconnect
    this.socket.on('disconnect', this.handleSocketDisconnected);

    // end chat
    this.socket.on('end_chat_by_supporter', this.handleEndChat);
  },

  /**
   * handle socket receive message
   * @param {*} msg
   */
  handleSocketReceiveMessage(msg) {
    const { config, model } = this;
    const session_id = Tools.getSessionId(config.domain_id);

    if (msg.session_id != session_id) {
      Tools.setSessionId(msg.session_id, config.domain_id);
    }
    config.dataMess.data.push(msg);

    if (msg.sender.sender_type == 'SUPPORTER') {
      config.supporter = msg.sender;
      config.mid_late = msg.mid;
    }

    model.trigger('onReceiveMessage', msg);
  },

  /**
   * handle socket disconnected
   */
  handleSocketDisconnected() {
    const { model } = this;
    model.trigger('onDisconnected');

    model.set('disconnect', true);
    this.socket.disconnect();
    this.connect();
  },

  /**
   * handle end chat by supporter
   */
  handleEndChat() {
    const { model } = this;
    model.trigger('onEndChat');
  },

  render() {
    const model = this.model;
    return this;
  }
});
